import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isDarkTheme } from '../../../../eliot-components/src/theme';

export default makeStyles((theme: Theme) => ({
  field: {
    marginBottom: '15px',
  },
  fieldText: {
    marginBottom: '15px',
    marginLeft: '15px',
  },
  careLabel: {
    backgroundColor: isDarkTheme(theme) ? '#393939' : '#eeeeee',
    borderRadius: '4px',
  },
}));
